import React, { useEffect, useState, useRef } from 'react';
import { Dialog, DialogContent, Box } from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DateView } from '@mui/x-date-pickers/models';

type ReminderRescheduleModalProps = {
  open: boolean;
  onClose: () => void;
  onSave: (newDueAt: string, previousDueAt: string) => Promise<void>;
  currentDueAt?: string;
};

const ReminderRescheduleModal = ({
  open,
  onClose,
  onSave,
  currentDueAt,
}: ReminderRescheduleModalProps) => {
  const [previousDueAt, setPreviousDueAt] = useState<string | undefined>(currentDueAt);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const currentViewRef = useRef<DateView>('day');

  // Store the previous date and reset selected date when modal opens
  useEffect(() => {
    if (open && currentDueAt) {
      setPreviousDueAt(currentDueAt);
      setSelectedDate(new Date(currentDueAt));
    }
  }, [open, currentDueAt]);

  const handleViewChange = (view: DateView) => {
    currentViewRef.current = view;
  };

  const handleDateChange = async (newValue: Date | null) => {
    if (!newValue) return;

    // Always update the selected date for display
    setSelectedDate(newValue);

    // Only save and close when user clicks on a day (not when selecting year/month)
    if (currentViewRef.current === 'day' && previousDueAt) {
      await onSave(newValue.toISOString(), previousDueAt);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogContent sx={{ p: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <DateCalendar
            value={selectedDate}
            onChange={handleDateChange}
            onViewChange={handleViewChange}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReminderRescheduleModal;
